.dialog {
    @media (width <= 840px) {
        max-height: 97vh;
    }

    &.dialogFit {
        width: fit-content;
    }

    &.dialogFullWidth {
        width: 1176px;
        max-width: 95dvw;
    }

    h2 {
        font: var(--bi-font-title-bold-large);

        @media (width <= 840px) {
            font: var(--bi-font-title-bold-medium);
        }
    }

    .dialogHeader {
        display: flex;
        flex-direction: column;
        min-height: unset;

        @media (width <= 840px) {
            gap: unset;
        }

        .dialogHeaderRow {
            display: flex;
            justify-content: space-between;
            align-items: center;
            gap: var(--bi-scale-4x);
            width: 100%;
            height: 3.25rem;

            > .backButton {
                font-size: 0.875rem;
            }
        }

        .showOnlyFilter {
            margin-left: auto;

            &:last-child {
                margin-left: unset;
                width: 100%;
            }
        }

        > h2 {
            margin-top: var(--bi-scale-4x);
            text-align: left;
            width: 100%;

            &.selectDirectYearTitle {
                margin-top: 0;
                text-align: center;
                max-width: 328px;
            }
        }
    }

    .dialogContent {
        background: var(--bi-neutral-5);
        padding: var(--bi-scale-4x) 0;

        &.selectDirectYearDialogContent {
            background: unset;
            display: flex;
            flex-direction: column;
            align-items: center;
            gap: var(--bi-scale-3x);
            width: 100%;
            padding: var(--bi-scale-1-5x) var(--bi-scale-4x) var(--bi-scale-8x);
        }

        .showOnlyFilter {
            padding: 0 var(--bi-scale-4x) var(--bi-scale-4x);
        }

        .alertContainer {
            max-width: 34.5em;
            margin: var(--bi-scale-4x) auto;
            min-height: fit-content;
            font: var(--bi-font-body-large);
        }

        .cardsContainer {
            display: grid;
            grid-template-columns: repeat(3, minmax(0, 1fr));
            gap: var(--bi-scale-4x);
            width: 100%;
            min-height: fit-content;
            padding: var(--bi-scale-4x);

            @media (width <= 840px) {
                display: flex;
                flex-wrap: nowrap;
                overflow: auto;

                /* If there's only one child, center it */
                &:has(> :nth-child(1):last-child) {
                    justify-content: center;
                }
            }

            > .directStartDialogTrigger {
                margin: auto;
            }
        }

        .directStartDialogTrigger {
            white-space: nowrap;
            margin: var(--bi-scale-8x) auto;

            @media (width <= 840px) {
                margin: auto;
            }
        }
    }
}
